<template>
  <div class="self-mask">
    <el-dialog
      :close-on-click-modal="false"
      title="音频预览"
      :visible.sync="showPreview"
      width="600px"
      center
      @close="handleClose"
    >
      <div class="audio-content">
        <audio class="audio-dom" :src="url" width="" height="" controls></audio>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "HzxmanageAudioPreview",

  data() {
    return {
      showPreview: false,
      url: "",
    };
  },

  mounted() {},

  methods: {
    init() {
      this.showPreview = true;
    },
    handleClose() {
      setTimeout(() => {
        this.$destroy(true);
        this.$el && this.$el.parentNode.removeChild(this.$el);
      }, 500);
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  .el-dialog__body{
    padding-top: 0px;
  }
}
.self-mask {
  position: fixed;
  z-index: 9999999999;
  width: 100vw;
  height: 100vh;
  left: 0;
  top: 0;
  background-color: rgba($color: #000000, $alpha: 0.5);
}
.audio-content {
  min-height: 160px;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
